
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'AllScanModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['closeVirusScanModal', 'scanTerminal'],
  setup (props, context) {
    const modalVisiable = computed(() => props.show)
    return {
      modalVisiable,
      closeModal () {
        context.emit('closeVirusScanModal', 'MODAL_ALL_SCAN')
      },
      scanAllTerminal () {
        // eslint-disable-next-line no-magic-numbers
        context.emit('scanTerminal', 2)
        context.emit('closeVirusScanModal', 'MODAL_ALL_SCAN')
      }
    }
  }
})
